import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

import queryString from 'query-string';

// Loader Components
import showLoader from '@components/loader';
import { getKycDocWithVehicle } from '../../KycDoc/store';

export const getVehicle = createAsyncThunk('vehicleSlice/getVehicle', async () => {
    try {
        let response = await axios.get('/vehicle', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleOption = createAsyncThunk('vehicleSlice/getVehicleOption', async () => {
    try {
        // showLoader(true);
        let response = await axios.get('/vehicle?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleOptionWithFilter = createAsyncThunk('vehicleSlice/getVehicleOptionWithFilter', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/vehicle/with-filters?option=true&skip=0&take=5' + `&${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getVehicleAppUserOption = createAsyncThunk('vehicleSlice/getVehicleAppUserOption', async (id) => {
    try {
        // showLoader(true);
        let response = await axios.get('/vehicle/app-user/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getAppUserOption = createAsyncThunk('vehicleSlice/getAppUserOption', async () => {
    try {
        // showLoader(true);
        let response = await axios.get('/app-user/option', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createVehicle = createAsyncThunk('vehicleSlice/createVehicle', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/vehicle', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Vehicle created successfully.');
        dispatch(getVehicle());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateVehicle = createAsyncThunk('vehicleSlice/updateVehicle', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/vehicle/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Vehicle updated successfully.');
        dispatch(getVehicle());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteVehicle = createAsyncThunk('vehicleSlice/deleteVehicle', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/vehicle/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Vehicle deleted successfully');
        dispatch(getVehicle());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateVehicleStatus = createAsyncThunk('vehicleSlice/updateVehicleStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/vehicle/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getVehicle());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const vehicleSlice = createSlice({
    name: 'vehicleSlice',
    initialState: {
        data: [],
        option: [],
        optionWithFilter: [],
        appUserOption: [],
        vehicalAppUserOption: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getVehicle.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getVehicleOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
        builder.addCase(getVehicleOptionWithFilter.fulfilled, (state, action) => {
            state.optionWithFilter = action.payload;
            return;
        });
        builder.addCase(getVehicleAppUserOption.fulfilled, (state, action) => {
            state.vehicalAppUserOption = action.payload;
            return;
        });
        builder.addCase(getAppUserOption.fulfilled, (state, action) => {
            state.appUserOption = action.payload;
            return;
        });
    }
});

export default vehicleSlice.reducer;
